'use client';
// DateFilters component - Stub file to fix build error
import { Box, Chip } from '@mui/material';

interface DateFiltersProps {
  selectedDate?: string;
  onDateSelect?: (date: string) => void;
}

export function DateFilters({ selectedDate, onDateSelect }: DateFiltersProps) {
  const dates = ['Past', 'Jan 31', 'Mar 31', 'Jun 30', 'Dec 31'];

  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 2, overflowX: 'auto', pb: 0.5 }}>
      {dates.map((date) => (
        <Chip
          key={date}
          label={date}
          onClick={() => onDateSelect?.(date)}
          sx={{
            bgcolor: selectedDate === date ? 'primary.main' : 'transparent',
            color: selectedDate === date ? '#ffffff' : 'text.primary',
            border: '1px solid',
            borderColor: selectedDate === date ? 'primary.main' : 'divider',
            '&:hover': {
              bgcolor: selectedDate === date ? 'primary.dark' : 'action.hover',
            },
          }}
        />
      ))}
    </Box>
  );
}
